import { useState, useEffect } from "react";
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/24/solid";
import Audi from "images/nissan.png";
import BMW from "images/Jeep.png";
import Kia from "images/mazda.png";
import Peugeot from "images/bmw.png";
import volkswagon from "images/porche.png";
import ford from "images/Ford.png";
import tesla from "images/tesla.png";
import acura from "images/accura.png";

const brands = [
  { name: "Nissan", logo: Audi },
  { name: "Jeep", logo: BMW },
  { name: "Mazda", logo: Kia },
  { name: "BMW", logo: Peugeot },
  { name: "Porsche", logo: volkswagon },
  { name: "Ford", logo: ford },
  { name: "Tesla", logo: tesla },
  { name: "Acura", logo: acura },
];

const CarLogo = () => {
  const [visibleStartIndex, setVisibleStartIndex] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(2);

  const handleResize = () => {
    if (window.innerWidth >= 1280) {
      setItemsPerPage(5); // xl
    } else if (window.innerWidth >= 1024) {
      setItemsPerPage(4); // lg
    } else if (window.innerWidth >= 768) {
      setItemsPerPage(3); // md
    } else {
      setItemsPerPage(2); // sm
    }
  };

  useEffect(() => {
    handleResize(); // Set initial items per page
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleNext = () => {
    if (visibleStartIndex + itemsPerPage < brands.length) {
      setVisibleStartIndex(visibleStartIndex + itemsPerPage);
    }
  };

  const handlePrevious = () => {
    if (visibleStartIndex - itemsPerPage >= 0) {
      setVisibleStartIndex(visibleStartIndex - itemsPerPage);
    }
  };

  return (
    <>
      <div className="flex items-center w-full"></div>
      <div className="flex flex-row justify-end space-x-2 !mt-2 pr-4">
        <button
          className={`w-10 h-10 flex items-center justify-center rounded-full bg-[#F5F5F71A] hover:bg-[#F5F5F71A] ${
            visibleStartIndex === 0 ? "opacity-50 cursor-not-allowed" : ""
          }`}
          aria-label="Previous"
          onClick={handlePrevious}
          disabled={visibleStartIndex === 0}
        >
          <ChevronLeftIcon className="w-6 h-6 text-primary-100" />
        </button>
        <button
          className={`w-10 h-10 flex items-center justify-center rounded-full bg-[#F5F5F71A] hover:bg-[#F5F5F71A] ${
            visibleStartIndex + itemsPerPage >= brands.length
              ? "opacity-50 cursor-not-allowed"
              : ""
          }`}
          aria-label="Next"
          onClick={handleNext}
          disabled={visibleStartIndex + itemsPerPage >= brands.length}
        >
          <ChevronRightIcon className="w-6 h-6 text-primary-100" />
        </button>
      </div>
      <div className="flex justify-center !mt-12">
        <div
          className={`grid gap-12 `}
          style={{
            gridTemplateColumns: `repeat(${itemsPerPage}, minmax(0, 1fr))`,
          }}
        >
          {brands
            .slice(visibleStartIndex, visibleStartIndex + itemsPerPage)
            .map((brand, index) => (
              <div
                key={index}
                className="flex flex-col items-center p-4 bg-[#FFFFFF0D] rounded-lg shadow hover:shadow-md transition min-w-[150px] md:min-w-[200px]"
              >
                <img
                  src={brand.logo}
                  alt={`${brand.name} logo`}
                  className="w-28 h-28 mb-2"
                />
                <span className="text-[#F5F5F780] font-medium">
                  {brand.name}
                </span>
              </div>
            ))}
        </div>
      </div>
    </>
  );
};

export default CarLogo;
